<script setup>
import { defineProps, ref, onMounted, watch } from "vue";

const props = defineProps({
  media_link: String,
});

const videoElement = ref(null);
const isPlaying = ref(false);
const isMuted = ref(false);
const isFullscreen = ref(false);
const currentTime = ref(0);
const duration = ref(0);
const full = ref(false);

watch(
  () => props.videoSrc,
  () => {
    if (videoElement.value) {
      videoElement.value.src = props.videoSrc;
    }
  }
);

const handlePlay = () => {
  isPlaying.value = true;
};

const handlePause = () => {
  isPlaying.value = false;
};

const handleEnded = () => {
  isPlaying.value = false;
  currentTime.value = 0;
};

const togglePlay = () => {
  if (videoElement.value) {
    if (isPlaying.value) {
      videoElement.value.pause();
    } else {
      videoElement.value.play();
    }
  }
};

const toggleMute = () => {
  if (videoElement.value) {
    videoElement.value.muted = !videoElement.value.muted;
    isMuted.value = videoElement.value.muted;
  }
};

const seek = () => {
  if (videoElement.value) {
    videoElement.value.currentTime = currentTime.value;
  }
};

const toggleFullscreen = () => {
  isFullscreen.value = !isFullscreen.value;

  // if (isFullscreen.value) {
    if (videoElement.value.requestFullscreen) {
      videoElement.value.requestFullscreen();
    } else if (videoElement.value.webkitRequestFullscreen) {
      videoElement.value.webkitRequestFullscreen();
    } else if (videoElement.value.msRequestFullscreen) {
      videoElement.value.msRequestFullscreen();
    }
  // } else {
  //   if (document.exitFullscreen) {
  //     document.exitFullscreen();
  //   } else if (document.webkitExitFullscreen) {
  //     document.webkitExitFullscreen();
  //   } else if (document.msExitFullscreen) {
  //     document.msExitFullscreen();
  //   }
  // }
};

onMounted(() => {
  const video = videoElement.value;
  if (video) {
    video.addEventListener("loadedmetadata", () => {
      duration.value = video.duration;
    });

    video.addEventListener("timeupdate", () => {
      currentTime.value = video.currentTime;
    });
  }

  videoElement.value.addEventListener("contextmenu", function (event) {
    event.preventDefault();
  });

  togglePlay();
});
</script>

<template>
  <!-- :class="{ fullscreen: isFullscreen }" -->
  <div class="video-player">
    <div class="video-container">
      <video
        v-if="media_link"
        ref="videoElement"
        :src="media_link"
        @play="handlePlay"
        @pause="handlePause"
        @ended="handleEnded"
        @click="togglePlay"
        @dblclick="toggleFullscreen"
        controlsList="nodownload noremoteplayback noplaybackrate"
      />
    </div>
    <div class="controls">
      <button class="play_btn" @click="togglePlay">
        <img
          v-if="isPlaying"
          src="@/assets/images/video/pause_btn.svg"
          alt="icon"
        />
        <img v-else src="@/assets/images/video/play_btn.svg" alt="icon" />
      </button>

      <input
        type="range"
        min="0"
        :max="duration"
        v-model="currentTime"
        @input="seek"
      />

      <button class="muted_btn" @click="toggleMute">
        <!-- {{ isMuted ? "Unmute" : "Mute" }} -->
        <img
          v-if="isMuted"
          src="@/assets/images/video/mute_off_btn.svg"
          alt="icon"
        />
        <img v-else src="@/assets/images/video/mute_btn.svg" alt="icon" />
      </button>
      <button class="full_btn" @click="toggleFullscreen">
        <!-- {{ isFullscreen ? "X Full" : "Full" }} -->
        <!-- <img
          src="@/assets/images/video/full_exit.svg"
          alt="icon"
        /> -->
        <!-- v-if="isFullscreen"-->
        <!-- v-else -->
        <img src="@/assets/images/video/full.svg" alt="icon" /> 
      </button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.video-player {
  position: relative;
  width: 100%;
  // height: auto;
  aspect-ratio: 16 / 9;
  // transition: 0.1s;
  &.fullscreen {
    display: grid;
    grid-auto-rows: calc(100% - 35px) 35px;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
  }
}

.video-container {
  position: relative;
}

video {
  width: 100%;
  // height: auto;
  height: 100%;
  display: block;
  background-color: #000;
  // &::-webkit-media-controls-enclosure {
  //   display: none !important; /* 隱藏所有內建控制項 */
  // }

  // &::-webkit-media-controls-playback-rate-button,
  // &::-webkit-media-controls-download-button,
  // &::-webkit-media-controls-pip-button {
  //   display: none !important; /* 分別隱藏播放速度、下載、子母畫面按鈕 */
  // }
}

.controls {
  display: flex;
  justify-content: center;
  align-items: center;
  // margin-top: 10px;
  height: 35px;
  width: 100%;
  background-color: #666;
  box-sizing: border-box;
  padding-left: 20px;
  padding-right: 20px;

  .play_btn,
  .muted_btn,
  .full_btn {
    width: 35px;
    height: 35px;
    background-color: transparent;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  input[type="range"] {
    margin: 0 10px;
    width: calc(100% - 35px - 35px - 35px);
  }
}

.fullscreen {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: black;
  z-index: 9999;

  video {
    width: 100%;
    height: 100%;
  }
}
</style>
